import React from 'react';
import { Svg, Path } from '@react-pdf/renderer';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function CheckCircle({ color = colors.primary['600'], ...props }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0375 2.5 13.5 4.96243 13.5 8C13.5 11.0375 11.0375 13.5 8 13.5C4.96243 13.5 2.5 11.0375 2.5 8ZM8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM11.0202 6.35355C11.2155 6.15829 11.2155 5.84171 11.0202 5.64645C10.8249 5.45119 10.5084 5.45119 10.3131 5.64645L7.33333 8.6262L6.35355 7.64647C6.15829 7.4512 5.84171 7.4512 5.64645 7.64647C5.45119 7.84173 5.45119 8.15827 5.64645 8.35353L6.9798 9.68687C7.07353 9.78067 7.20073 9.83333 7.33333 9.83333C7.46593 9.83333 7.59313 9.78067 7.68687 9.68687L11.0202 6.35355Z"
        fill={color}
      />
    </svg>
  );
}

export function PdfCheckCircle({ color = colors.primary['600'] }: Props) {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16">
      <Path
        fillRule="evenodd"
        d="M2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0375 2.5 13.5 4.96243 13.5 8C13.5 11.0375 11.0375 13.5 8 13.5C4.96243 13.5 2.5 11.0375 2.5 8ZM8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM11.0202 6.35355C11.2155 6.15829 11.2155 5.84171 11.0202 5.64645C10.8249 5.45119 10.5084 5.45119 10.3131 5.64645L7.33333 8.6262L6.35355 7.64647C6.15829 7.4512 5.84171 7.4512 5.64645 7.64647C5.45119 7.84173 5.45119 8.15827 5.64645 8.35353L6.9798 9.68687C7.07353 9.78067 7.20073 9.83333 7.33333 9.83333C7.46593 9.83333 7.59313 9.78067 7.68687 9.68687L11.0202 6.35355Z"
        fill={color}
      />
    </Svg>
  );
}
